<template>
  <div v-show="src && documentoCargado == 1.0">
    <!-- <button @click="$refs.myPdfComponent.print()">print</button> -->
    <!-- <pdf v-if="src && src.length" :src="src"></pdf> -->

    <div class="d-flex w-100 justify-content-between">
      <b-button :disabled="page == 1" @click="page--"><b-icon-arrow-left-circle></b-icon-arrow-left-circle></b-button>
      <div>{{ currentPage }} / {{ pageCount }}</div>
      <b-button :disabled="page == pageCount" @click="page++"><b-icon-arrow-right-circle></b-icon-arrow-right-circle></b-button>
    </div>
    <div>
      <pdf :src="src" ref="myPdfComponent" :page="page" @progress="documentoCargado = $event" @num-pages="pageCount = $event" @page-loaded="currentPage = $event"></pdf>
    </div>
    <div class="d-flex w-100 justify-content-between">
      <b-button class="btn btn-manusa" :disabled="page == 1" @click="page--"><b-icon-arrow-left-circle></b-icon-arrow-left-circle></b-button>
      <b-button class="btn btn-manusa" @click="forceFileDownload()"><b-icon-download></b-icon-download> Descargar PDF</b-button>
      <b-button class="btn btn-manusa" :disabled="page == pageCount" @click="page++"><b-icon-arrow-right-circle></b-icon-arrow-right-circle></b-button>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf';

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  b64Data = b64Data.replace(/^[^,]+,/, '');
  b64Data = b64Data.replace(/\s/g, '');
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
export default {
  name: 'AbrirPDF',
  components: {
    pdf
  },
  props: {
    titulo: {
      type: String,
      default: 'fichero.pdf'
    },
    src: null
  },
  data() {
    return {
      documentoCargado: 0,
      currentPage: 0,
      pageCount: 0,
      page: 1
    };
  },
  mounted() {
    this.documentoCargado = 0;
  },
  methods: {
    forceFileDownload() {
      console.log(this.titulo);
      const url = window.URL.createObjectURL(b64toBlob(this.src, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.titulo);
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style scoped>
.annotationLayer {
  background-color: #f0f8ff29;
}
</style>
